<priva-content-template>
    <priva-content-header [hasOffset]="true" [hasBottomPadding]="false">
        <priva-header [title]="'SETTINGS.HEADER.TITLE.TERMINAL_SETTINGS' | translate" size="md">
            <div data-end>
                @if (enableSaveBtn()) {
                    <button
                        class="save-btn"
                        [isDisabled]="(formIsDirty$ | async) === false || !formGroup.valid"
                        priva-button
                        (click)="save($event)"
                        iconState="only"
                        iconClass="fas fa-check"
                        importance="tertiary"
                        data-test="save-settings-button"
                        size="md"
                    ></button>
                }
                <button
                    priva-button
                    iconState="only"
                    importance="tertiary"
                    iconClass="fas fa-xmark"
                    size="md"
                    data-test="close-settings-btn"
                    (click)="navigateToHomePage()"
                ></button>
            </div>
        </priva-header>
    </priva-content-header>
    <div class="settings">
        @if (supervisorValidated$ | async) {
            <priva-form theme="onwhite" [hasTitle]="false" [formGroup]="formGroup">
                <priva-form-section [hasTitle]="false">
                    @if (deviceProfile$ | async; as deviceProfile) {
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label
                                >{{ 'GENERAL.TITLE.IDENTIFIER' | translate }}
                            </ng-container>
                            <priva-form-control-static data-test="api-version-form-control">
                                {{ identifier$ | async }}
                            </priva-form-control-static>
                        </priva-form-group>
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label>{{ 'GENERAL.TITLE.APP_MODE' | translate }}</ng-container>
                            <priva-form-control-static data-test="api-version-form-control">
                                {{ getAppModeOptionName(deviceProfile.appMode) | translate }}
                            </priva-form-control-static>
                        </priva-form-group>

                        @if (deviceProfile.appMode === 'personal') {
                            <priva-form-group [hasLabel]="true">
                                <ng-container data-label>
                                    {{ 'GENERAL.TITLE.INPUT_MODE' | translate }}
                                </ng-container>
                                <priva-form-control-static data-test="api-version-form-control">
                                    {{ getInputModeName(deviceProfile.inputMode) | translate }}
                                </priva-form-control-static>
                            </priva-form-group>
                        }

                        @if (isPersonalScanMode(deviceProfile.appMode, deviceProfile.inputMode)) {
                            <priva-form-group [hasLabel]="true">
                                <ng-container data-label>
                                    {{ 'GENERAL.TITLE.ALLOW_MANUAL_SELECTION' | translate }}
                                </ng-container>
                                @for (
                                    allowManualSelectionOption of allowManualSelectionOptions;
                                    track allowManualSelectionOption.value
                                ) {
                                    <priva-radio
                                        id="input-mode-item-radio-{{ allowManualSelectionOption.value }}"
                                        theme="onwhite"
                                    >
                                        <input
                                            type="radio"
                                            [value]="allowManualSelectionOption.value"
                                            formControlName="allowManualSelection"
                                            [attr.data-test]="
                                                'radio-btn-input-mode-' + allowManualSelectionOption.value
                                            "
                                        />
                                        <span data-label>{{
                                            allowManualSelectionOption.name | translate
                                        }}</span>
                                    </priva-radio>
                                }
                            </priva-form-group>
                        }

                        @if (deviceProfile.appMode === 'personal' && deviceProfile.inputMode !== 'manual') {
                            <priva-form-group [hasLabel]="true">
                                <ng-container data-label
                                    >{{ 'SETTINGS.TITLE.REGISTRATION_SUBMISSION_INTERVAL' | translate }}
                                </ng-container>
                                <priva-form-control-static data-test="api-version-form-control">
                                    {{ deviceProfile.submissionIntervalSeconds }}
                                </priva-form-control-static>
                            </priva-form-group>
                        }
                    } @else {
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label
                                >{{ 'GENERAL.TITLE.IDENTIFIER' | translate }}
                            </ng-container>
                            <input
                                type="text"
                                readonly
                                priva-input
                                placeholder="Identifier"
                                formControlName="identifier"
                            />
                        </priva-form-group>
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label>{{ 'GENERAL.TITLE.APP_MODE' | translate }}</ng-container>
                            @for (appModeOption of appModeOptions; track appModeOption.mode) {
                                <priva-radio id="mode-item-radio-{{ appModeOption.mode }}" theme="onwhite">
                                    <input
                                        type="radio"
                                        [value]="appModeOption.mode"
                                        formControlName="appMode"
                                        [attr.data-test]="'radio-btn-app-mode-' + appModeOption.mode"
                                    />
                                    <span data-label>{{ appModeOption.name | translate }}</span>
                                </priva-radio>
                            }
                        </priva-form-group>
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label>
                                {{ 'GENERAL.TITLE.INPUT_MODE' | translate }}
                            </ng-container>
                            @for (inputModeOption of inputModeOptions; track inputModeOption.mode) {
                                <priva-radio
                                    id="input-mode-item-radio-{{ inputModeOption.mode }}"
                                    theme="onwhite"
                                >
                                    <input
                                        type="radio"
                                        [value]="inputModeOption.mode"
                                        formControlName="inputMode"
                                        [attr.data-test]="'radio-btn-input-mode-' + inputModeOption.mode"
                                    />
                                    <span data-label>{{ inputModeOption.name | translate }}</span>
                                </priva-radio>
                            }
                        </priva-form-group>
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label>
                                {{ 'GENERAL.TITLE.ALLOW_MANUAL_SELECTION' | translate }}
                            </ng-container>
                            @for (
                                allowManualSelectionOption of allowManualSelectionOptions;
                                track allowManualSelectionOption.value
                            ) {
                                <priva-radio
                                    id="input-mode-item-radio-{{ allowManualSelectionOption.value }}"
                                    theme="onwhite"
                                >
                                    <input
                                        type="radio"
                                        [value]="allowManualSelectionOption.value"
                                        formControlName="allowManualSelection"
                                        [attr.data-test]="
                                            'radio-btn-input-mode-' + allowManualSelectionOption.value
                                        "
                                    />
                                    <span data-label>{{ allowManualSelectionOption.name | translate }}</span>
                                </priva-radio>
                            }
                        </priva-form-group>
                        <priva-form-group [hasLabel]="true">
                            <ng-container data-label
                                >{{ 'SETTINGS.TITLE.REGISTRATION_SUBMISSION_INTERVAL' | translate }}
                            </ng-container>
                            <input
                                type="number"
                                priva-input
                                placeholder="Submission interval"
                                formControlName="scanFlowRegistrationSubmitIntervalSec"
                                data-test="scan-flow-reg-submit-interval-input"
                            />
                            @if (scanFlowRegistrationSubmitIntervalSec.errors?.['min']) {
                                <priva-notification
                                    status="Danger"
                                    data-test="scan-flow-reg-submit-interval-min-value-error"
                                    >{{ 'ERROR.TITLE.VALUE_MUST_BE_MORE_THAN_0_SECONDS' | translate }}
                                </priva-notification>
                            }
                            @if (scanFlowRegistrationSubmitIntervalSec.errors?.['required']) {
                                <priva-notification
                                    status="Danger"
                                    data-test="scan-flow-reg-submit-interval-required-error"
                                    >{{ 'ERROR.TITLE.VALUE_CANNOT_BE_EMPTY' | translate }}
                                </priva-notification>
                            }
                        </priva-form-group>
                    }
                </priva-form-section>

                <priva-form-section [hasTitle]="true">
                    <ng-container data-title>{{ 'GENERAL.TITLE.STATUS' | translate }}</ng-container>
                    @if (registrationError$ | async; as error) {
                        <input type="text" readonly priva-input [value]="error.errorMessage" />
                    } @else {
                        <i class="fas fa-check-circle"></i>
                    }
                </priva-form-section>
                <priva-form-section [hasTitle]="true">
                    <ng-container data-title
                        >{{ 'SETTINGS.TITLE.CACHED_REGISTRATIONS' | translate }}
                    </ng-container>
                    <app-registrations-table />
                </priva-form-section>
                <priva-form-section [hasTitle]="true">
                    <ng-container data-title>{{ 'SETTINGS.TITLE.ACTIONS' | translate }}</ng-container>
                    <table class="settings__action-table">
                        <tr>
                            <td>
                                <button priva-button (click)="clearRegistrations()">
                                    {{ 'SETTINGS.ACTION.CLEAR_REGISTRATIONS' | translate }}
                                </button>
                            </td>
                            <td>{{ 'SETTINGS.INFO.CLEAR_REGISTRATIONS' | translate }}</td>
                        </tr>
                        <tr>
                            <td>
                                <button priva-button (click)="clearPreferences()">
                                    {{ 'SETTINGS.ACTION.CLEAR_RECENT' | translate }}
                                </button>
                            </td>
                            <td>{{ 'SETTINGS.ACTION.CLEAR_RECENT' | translate }}</td>
                        </tr>
                        <tr>
                            <td>
                                <button priva-button (click)="clearMasterData()">
                                    {{ 'SETTINGS.ACTION.CLEAR_DATA' | translate }}
                                </button>
                            </td>
                            <td>{{ 'SETTINGS.INFO.CLEAR_DATA' | translate }}</td>
                        </tr>
                        <tr>
                            <td>
                                <button priva-button (click)="clear()" data-test="clear-all-btn">
                                    {{ 'SETTINGS.ACTION.CLEAR_ALL' | translate }}
                                </button>
                            </td>
                            <td>{{ 'SETTINGS.INFO.CLEAR_ALL' | translate }}</td>
                        </tr>
                    </table>
                </priva-form-section>
                <priva-form-group>
                    <ng-container data-label>{{ 'GENERAL.TITLE.API_VERSION' | translate }}</ng-container>
                    <priva-form-control-static data-test="api-version-form-control">
                        {{ apiVersion$ | async }} ({{ ApiVersion[apiVersion$ | async] }})
                    </priva-form-control-static>
                </priva-form-group>
            </priva-form>
        } @else {
            <app-signin-form
                [title]="'GENERAL.TITLE.ENTER_CREDENTIALS' | translate"
                [requiredRoles]="['supervisor']"
                (authorized)="onNewSignin($event)"
            />
        }
    </div>
</priva-content-template>
